/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser } from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser';
import {
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserFromJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserFromJSONTyped,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserToJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserToJSONTyped,
} from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser';
import type { UpdateScreenerSettingRequest } from './UpdateScreenerSettingRequest';
import {
    UpdateScreenerSettingRequestFromJSON,
    UpdateScreenerSettingRequestFromJSONTyped,
    UpdateScreenerSettingRequestToJSON,
    UpdateScreenerSettingRequestToJSONTyped,
} from './UpdateScreenerSettingRequest';

/**
 * 
 * @export
 * @interface FindAllScreenerAdmissionFlags200ResponseDataInner
 */
export interface FindAllScreenerAdmissionFlags200ResponseDataInner {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    first_name: string;
    /**
     * 
     */
    last_name: string;
    /**
     * 
     */
    dob?: string;
    /**
     * 
     */
    category: FindAllScreenerAdmissionFlags200ResponseDataInnerCategoryEnum;
    /**
     * 
     */
    comment?: string;
    /**
     * 
     */
    created_at?: string;
    /**
     * 
     */
    created_by_user?: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser;
    /**
     * 
     */
    gender?: string | null;
    /**
     * 
     */
    aliases?: Array<UpdateScreenerSettingRequest>;
}


/**
 * @export
 */
export const FindAllScreenerAdmissionFlags200ResponseDataInnerCategoryEnum = {
    Behavioral: 'Behavioral',
    Financial: 'Financial',
    Clinical: 'Clinical',
    Other: 'Other',
} as const;
export type FindAllScreenerAdmissionFlags200ResponseDataInnerCategoryEnum = typeof FindAllScreenerAdmissionFlags200ResponseDataInnerCategoryEnum[keyof typeof FindAllScreenerAdmissionFlags200ResponseDataInnerCategoryEnum];


/**
 * Check if a given object implements the FindAllScreenerAdmissionFlags200ResponseDataInner interface.
 */
export function instanceOfFindAllScreenerAdmissionFlags200ResponseDataInner(value: object): value is FindAllScreenerAdmissionFlags200ResponseDataInner {
    if (!('first_name' in value) || value['first_name'] === undefined) return false;
    if (!('last_name' in value) || value['last_name'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    return true;
}

export function FindAllScreenerAdmissionFlags200ResponseDataInnerFromJSON(json: any): FindAllScreenerAdmissionFlags200ResponseDataInner {
    return FindAllScreenerAdmissionFlags200ResponseDataInnerFromJSONTyped(json, false);
}

export function FindAllScreenerAdmissionFlags200ResponseDataInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllScreenerAdmissionFlags200ResponseDataInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'dob': json['dob'] == null ? undefined : json['dob'],
        'category': json['category'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'created_at': json['created_at'] == null ? undefined : json['created_at'],
        'created_by_user': json['created_by_user'] == null ? undefined : FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserFromJSON(json['created_by_user']),
        'gender': json['gender'] === undefined ? undefined : json['gender'] === null ? null : json['gender'],
        'aliases': json['aliases'] == null ? undefined : ((json['aliases'] as Array<any>).map(UpdateScreenerSettingRequestFromJSON)),
    };
}

export function FindAllScreenerAdmissionFlags200ResponseDataInnerToJSON(json: any): FindAllScreenerAdmissionFlags200ResponseDataInner {
    return FindAllScreenerAdmissionFlags200ResponseDataInnerToJSONTyped(json, false);
}

export function FindAllScreenerAdmissionFlags200ResponseDataInnerToJSONTyped(value?: FindAllScreenerAdmissionFlags200ResponseDataInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'dob': value['dob'],
        'category': value['category'],
        'comment': value['comment'],
        'created_at': value['created_at'],
        'created_by_user': FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserToJSON(value['created_by_user']),
        'gender': value['gender'],
        'aliases': value['aliases'] == null ? undefined : ((value['aliases'] as Array<any>).map(UpdateScreenerSettingRequestToJSON)),
    };
}

